export default {
    computed: {

        
    },
    watch: {

    },
    methods: {
        getCustomEntityId(value, entityList, entityFieldName, entityName) {
            const entity = entityList.find(x => x[entityFieldName] == value)
            if (entity == null)
                throw new Error(`${entityName}:${value} does not exist.`)
            return entity.id
        },
    },
}
